<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
              <h1 class="page-title-accessibility">Participant Referrals</h1>
            <div class="action">
                @if(!isReadOnly){
                <ppl-button label="Create New Participant Referral" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" [authorizeButton]="[pageId, 'newConsumerReferral']"
                    (click)="onNewReferral()"></ppl-button>
                }
            </div>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="table-style">
                    <ppl-list-table
                        rowDataAccessibilityKey="tracking_number"
                        [pageConfig]="programName"
                        [sharedDataKey]="sharedDataKey"
                        (rowDetailEvent)="rowClicked($event)"
                        [loadPage]="lazyLoad"
                        [enablePageActions]="true"
                        [columnsToBeHidden]="columnsToBeHidden"
                        [actionsToBeHidden]="actionsToBeHidden"
                        [badgeColumns]="['Application Status']"
                        [jsonList]="'list_referrals'">
                    </ppl-list-table>
                </div>
            </div>
        </div>
    </div>
    }

</ng-container>